import axios from 'axios'

// Update profile function
export function getTimeZones({ state, commit }) {
    return new Promise((resolve, reject) => {
        axios
            .get("timezonelist")
            .then(response => {
                commit('setTimezones', response.data.data)
                resolve(true)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function getQuotes({ state, commit }) {


    if (!state.quotes) {
        return new Promise((resolve, reject) => {
            axios
                .get("quotes/dailyquotes")
                .then(response => {
                    commit('setQuotes', response.data.data[0])
                    resolve(true)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }
}

export function logEvent({ commit, store }, props) {

    return new Promise((resolve, reject) => {
        axios
            .post('/logs/app', props, {
                headers: {
                    'Device-Type': 'customer_web_app'
                }
            })
            .then(response => {
                resolve(response)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function resetStore({ commit, store }) {
    commit('resetStore')
}